module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/clubpilates-30c7bc8b2da961e69c78c72e68777454.png";